import { createI18n } from 'vue-i18n';

import en from "./locales/en.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import zhHans from "./locales/zh-hans.json";
import zhHant from "./locales/zh-hant.json";

// 导入每种语言的翻译文件
const messages = {
  en,
  ja,
  ko,
  "zh-hans": zhHans,
  "zh-hant": zhHant,
};

// 创建i18n实例
const i18n = createI18n({
  legacy: false,
  silentTranslationWarn: true,  
  locale: localStorage.getItem("BEART_LANGUAGE_LOCALE") || "en", // 默认语言
  fallbackLocale: "en", // 如果没有找到翻译，回退到这个语言
  messages, // 所有翻译消息
  missingWarn: false, // 禁用缺失翻译警告  
  fallbackWarn: false  // 禁用回退警告
});

export default i18n;
